import { createSlice } from '@reduxjs/toolkit';

export const selectedApplicationSlice = createSlice({
    name: 'app/selectedApplication',
    initialState: { selectedApplication: '' },
    reducers: {
        setSelectedApplication: (state, action) => {
            state.selectedApplication = action.payload;
        },
    },
});

export const { setSelectedApplication } = selectedApplicationSlice.actions;
export default selectedApplicationSlice.reducer;
